import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import AdminPlaces from "@/pages/admin/Places";
import AdminSpots from "@/pages/admin/Spots";
import { usePrefs } from "@/contexts/PrefsContext";

const TABS = ["partners", "platform"] as const;

export default function AdminPublicPlaces() {
  const { t } = usePrefs();
  const [tab, setTab] = useState<(typeof TABS)[number]>(useLocation().pathname.startsWith("/admin/spots") ? "platform" : "partners");
  return (
    <div data-testid="admin-public-places-page" className="space-y-5">
      <div className="flex gap-2 overflow-x-auto no-scrollbar">
        {TABS.map((k) => (
          <button key={k} data-testid={`public-places-tab-${k}`} aria-pressed={tab === k} onClick={() => setTab(k)}
            className={`h-10 px-5 shrink-0 whitespace-nowrap rounded-full text-sm font-bold transition-[background-color,color] ${tab === k ? "bg-foreground text-background" : "bg-card border hover:bg-accent"}`}>{t(`pp.${k}`)}</button>
        ))}
      </div>
      {tab === "partners" ? <AdminPlaces /> : <AdminSpots />}
    </div>
  );
}
